<template>
  <div>
    <modal
      name="thumbnailListModal"
      :scrollable="true"
      delay="2000"
      width="100%"
      height="auto"
      style="z-index: 9998;"
      @closed="closeModal"
    >
      <div id="modalAreaThumbnailList" class="modalArea">
        <div class="content cleafix">

          <h2>100 Cultural &amp; Landscape Photos of Japan</h2>

          <div id="menuThumbnailList">
            <div id="menuAll" :class="allON"><img src="/img/blank.gif" alt="全ての季節" @click="changeSeason(EnumSeasonAll)"></div>
            <div id="menuSpring" :class="springON"><img src="/img/blank.gif" alt="春 spring" @click="changeSeason(EnumSeasonSpring)"></div>
            <div id="menuSummer" :class="summerON"><img src="/img/blank.gif" alt="夏 summer" @click="changeSeason(EnumSeasonSummer)"></div>
            <div id="menuAutumn" :class="autumnON"><img src="/img/blank.gif" alt="秋 autumn" @click="changeSeason(EnumSeasonAutumn)"></div>
            <div id="menuWinter" :class="winterON"><img src="/img/blank.gif" alt="冬 winter" @click="changeSeason(EnumSeasonWinter)"></div>
          </div><!-- /menuThumbnailList -->

          <div id="thumbnailList">
            <div v-for="(work) in works" :key="work.id" class="thumbnailArea">
              <div class="thumbnailImg fade" :style="`background-image:url(${work.thumbnailUrl})`" @click="clickWork(work)"><img src="/img/blank.gif"></div>
            </div><!-- /thumbnailArea -->
          </div><!-- /photoList -->

        </div><!-- /content -->
      </div><!-- /modalArea -->
      <div v-if="open" class="closeModalBotton fade" @click="closeModal"><img src="/img/blank.gif"></div>
    </modal>
  </div>
</template>

<script>
import enumMixin from '@/concern/enumMixin'
export default {
  mixins: [enumMixin], // Enum値の読み込み
  props: [
    'works',
    'season',
    'open'
  ],
  data () {
    return {
    }
  },
  computed: {
    allON () {
      return this.season === this.EnumSeasonAll ? 'on' : 'fade'
    },
    springON () {
      return this.season === this.EnumSeasonSpring ? 'on' : 'fade'
    },
    summerON () {
      return this.season === this.EnumSeasonSummer ? 'on' : 'fade'
    },
    autumnON () {
      return this.season === this.EnumSeasonAutumn ? 'on' : 'fade'
    },
    winterON () {
      return this.season === this.EnumSeasonWinter ? 'on' : 'fade'
    }
  },
  methods: {
    closeModal () {
      this.$emit('update:open', false)
      this.$modal.hide('thumbnailListModal')
      const path = '/'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '東京カメラ部 日本写真100景 ～日本は発見を待っている。～'
    },
    changeSeason (season) {
      let seasonText = ''
      if (season === this.EnumSeasonAll) seasonText = 'all'
      if (season === this.EnumSeasonSpring) seasonText = 'spring'
      if (season === this.EnumSeasonSummer) seasonText = 'summer'
      if (season === this.EnumSeasonAutumn) seasonText = 'autumn'
      if (season === this.EnumSeasonWinter) seasonText = 'winter'
      this.$ga.event('Thumbnail Modal Change Season', 'click', seasonText, null)
      this.$emit('change', season)
    },
    clickWork (work) {
      this.$ga.event('Thumbnail Modal Work Image', 'click', `work_${work.id}`, null)
      this.closeModal()
      this.$emit('click', work)
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.$modal.show('thumbnailListModal')
      }
    }
  }
}
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}
.vm--modal {
  background-color:rgba(0,0,0,0) !important;
}
</style>
